import * as z from 'zod';

import { permissibleRouteKeys } from './permissible-route-keys';

export const navigationShortcutsSchema = z.array(
  z.object({
    id: permissibleRouteKeys,
    sortOrder: z.number(),
  })
);

export type NavigationShortcutsSchema = z.infer<typeof navigationShortcutsSchema>;
